const OrderSummary = () => {
  return (
    <div className="flex flex-col h-full bg-white">
      <div className="p-5 border-b border-gray-200">
        <p className="text-lg font-bold text-gray-800">Order Summary & Checkout</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-5">
        <p className="text-sm text-gray-400">Add items to get started</p>
      </div>
    </div>
  );
};

export default OrderSummary;
